import { rem } from 'polished';

/**
 * Util function for font body CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontBody(fontSize = 12) {
  return `
    font-family: var(--bombas-font);
    font-size: ${rem(fontSize)};
    font-weight: 500;
    line-height: 1.5em;
    letter-spacing: ${rem(0.25)};
  `;
}

/**
 * Util function for font title CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontTitle(fontSize = 16) {
  return `
    font-family: var(--bombas-font);
    font-size: ${rem(fontSize)};
    font-weight: 700;
    line-height: 1.15em;
    letter-spacing: ${rem(0.33)};
  `;
}

/**
 * Util function for font accent CSS rules
 *
 * @param {number} fontSize Size of font in pixels
 * @returns {string} CSS rules to use for specified font size
 */
export function fontAccent(fontSize = 16) {
  return `
    font-family: var(--accent-font);
    font-size: ${rem(fontSize)};
    font-weight: 400;
    line-height: 1.15em;
    letter-spacing: 0;
  `;
}
